/**
 * General Service
 * Handles general API endpoints like health check, status, etc.
 */

import apiService from './api.service';
import { API_ENDPOINTS } from '../config/api.config';
import { HealthCheckResponse, StatusResponse } from '../types/api.types';

class GeneralService {
  /**
   * Get API status
   */
  async getStatus(): Promise<StatusResponse> {
    return await apiService.get<StatusResponse>(API_ENDPOINTS.STATUS);
  }

  /**
   * Get detailed health check
   */
  async getHealthCheck(): Promise<HealthCheckResponse> {
    return await apiService.get<HealthCheckResponse>(API_ENDPOINTS.HEALTH);
  }

  /**
   * Access protected resource (test authentication)
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async getProtectedResource(): Promise<any> {
    return await apiService.get(API_ENDPOINTS.PROTECTED);
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new GeneralService();

